export default __webpack_public_path__ + "static/media/schedule1_shrunk.88cb05f4.jpg";